import React, { useEffect, useState } from 'react';

/**
 * High5Ekim: Ekim 2026 değerlendirmesi, Eylül kıyaslı, marka bazında (harcama, ciro, stok, beden, indirim, fiyat, rakip).
 * Route: /r/high5-ekim (sidebar YOK, tam ekran slayt, 14 slayt 16:9, Türkçe).
 * Yeniden üretmek için: node src/pages/high5-ekim/build.js (veri: fetch_ga4.js, data.py, rakip.py) (PDF dahil)
 *
 * 🔴 iframe'e sandbox EKLEME, PDF indirme kırılır.
 * HTML modülü ~115KB, ana bundle'da işi yok: dinamik import ile yükleniyor.
 */
export default function High5Ekim() {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let alive = true;
    import('./high5EkimHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px;color:#1d1d1f">Sunum yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  const fill = { position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 0 };

  // Yükleme zemini sunumun kendi zemini (--deck) ile aynı, açılışta flaş olmasın.
  if (!html) return <div style={{ ...fill, background: '#F0F0F2' }} />;

  return (
    <iframe
      title="High5 · Ekim 2026 Değerlendirmesi"
      srcDoc={html}
      style={fill}
    />
  );
}
